import Utility from './Utility';
import RequestQueue from '../classes/RequestQueue';

class AdUnitCondition {
  static aucInstance = null;

  static instance() {
    AdUnitCondition.aucInstance = AdUnitCondition.aucInstance || new AdUnitCondition();

    return AdUnitCondition.aucInstance;
  }

  isAsyncMethod = (method) => {
    const methods = ['emailSubmittedDivActive']

    return methods.includes(method)
  }

  headerDropdownIsServed = () => {
    return Utility.getCookie('header_survey_served') != 'unknown'
  }

  emailSubmittedDivActive = async() => {
    const trackedUser = false;
    if (!trackedUser) return false;

    // check stock policy status
    const pathname = window.location.pathname.split('/')
    let stockSlug = pathname[pathname.length - 1];
    if (stockSlug.length == 0) {
      stockSlug = pathname[pathname.length - 2];
    }
    const stockRes = await RequestQueue.addToQueue({
      method: 'post',
      url: '/api/dividend/stocks/',
      data: {
        slug: stockSlug,
        columns: ['dividend_policy_active_status']
      }
    });

    if (stockRes.data.dividend_policy_active_status) {
      return true
    } else {
      return false
    }
  }

  exitInterstitialHasNotBeenServed = () => {
    const exitInterstitialShown = Utility.getCookie('O-02-A-shown');
    return exitInterstitialShown == 'unknown';
  }

  enterInterstitialHasNotBeenServed = () => {
    const welcomeInterstitialShown = Utility.getCookie('O-01-A-shown');
    return welcomeInterstitialShown == 'unknown';
  }

  stickyFooterHasNotBeenServed = () => {
    const stickyFooterAdShown = Utility.getCookie('FP-10-A-shown');
    return stickyFooterAdShown == 'unknown';
  }

}

export default AdUnitCondition.instance();
